var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"0 auto","width":"300px","height":"300px","line-height":"300px"}},[_c('a',{attrs:{"href":`lmapp://landingintl.com/verify-app?action=resetPassword&token=${_vm.token}`}},[_c('a-button',{attrs:{"type":"primary"}},[_vm._v("Open Beautyfluent App")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }